import React, { useEffect, useState, useRef } from 'react';
import { Tabs, Tab, Form, Button, Modal } from 'react-bootstrap/';
import Fullsize from "../../../../../assets/images/full-size.svg";
import { withoutRFSToken, withRFSToken } from '../../../../../Services/axios.js';
import { MSGPROCESSMVT } from '../../../../../Utils/conts.js';
import { toast } from 'react-toastify';
import Loader from '../../../../../Components/common/Loader.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const Process = ({ setLoading }) => {

  const isMounted = useRef(false);
  // const queryParameters = new URLSearchParams(window.location.search);
  // const type = queryParameters.get("action");
  // const uldids = queryParameters.get("ids");

  const actionTypes = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];
  let keyType = null;
  // Loop through the actionTypes array
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    // Check if the current key matches any of the action types
    if (actionTypes.includes(key)) {
      keyType = key;
      break;
    }
  }

  const storageData = JSON.parse(localStorage.getItem(keyType));
  let storageTab = '';
  if (storageData?.msgtype) {
    if (storageData.msgtype === 'UCM OUT') {
      storageTab = 'UCM';
    } else {
      storageTab = storageData.msgtype
    }
  } else {
    storageTab = 'UCM';
  }
  const storageMsg = storageData?.message ? storageData?.message : '';

  useEffect(() => {
    if (isMounted.current) return;
    const msgty = storageData.msgtype === 'UCM OUT' ? 'ucm_out' : storageData.msgtype === 'FFM' ? 'ffm' : storageData.msgtype === 'CPM' ? 'cpm' : '';
    if (storageData.message) {
      handleProcessButtonClick(msgty);
    }
    isMounted.current = true;
  }, [])

  const [activeTab, setActiveTab] = useState(storageTab);
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [showProcess, setShowProcess] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [processText, setProcessText] = useState(storageMsg);
  const [ucmOutText, setUcmOutText] = useState(storageMsg);
  const [ffmText, setFfmText] = useState(storageMsg);
  const [cpmText, setCpmText] = useState(storageMsg);
  const [uldProcessText, setUldProcessText] = useState('');
  const handleCloseProcess = () => { setShowProcess(false); };
  const handleCloseInfo = () => { setShowInfo(false); };
  const handleFullsizeClick = (event) => {
    event.preventDefault();
    setShowProcess(true);
  };
  const handleInfoClick = (event) => {
    event.preventDefault();
    setShowInfo(true);
  };

  // const handleTextareaChange = (e) => {
  //   setProcessText(e.target.value);
  //   setUcmOutText(e.target.value);
  //   setFfmText(e.target.value);
  //   setCpmText(e.target.value);
  // };
  const handleTextareaChange = (e) => {
    const { name, value } = e.target;

    // Update state based on the name of the textarea
    if (name === 'ucm_out') {
      setUcmOutText(value);
    } else if (name === 'ffm') {
      setFfmText(value);
    } else if (name === 'cpm') {
      setCpmText(value);
    } else if (name === 'process') {
      setProcessText(value);
    } else if (name === 'ULD') {
      setUldProcessText(value);
    }
  };

  const handleProcessButtonClick = async (msgFor) => {
    setIsLoading(true);
    setLoading(true);
    // Process the data in processText
    let keyTypeMapping;
    // if (!keyType == 'UCM Out'){
    keyTypeMapping = {
      'Lease Out': 'LEO',
      'SCM': 'SCM',
      // 'UCM Out': 'UO',
      'UCM In': 'UI',
      'LUC In': 'LI',
      'LUC Out': 'LO',
    };
    // } else {
    let keyTypeMappingUO;
    if (msgFor == 'ucm_out') {
      keyTypeMappingUO = 'UO'
    } else if (msgFor == 'ffm') {
      keyTypeMappingUO = 'FFM'
    } else if (msgFor == 'cpm') {
      keyTypeMappingUO = 'CPM'
    } else if (msgFor == 'ULD') {
      keyTypeMappingUO = 'charter_uld'
    }
    // keyTypeMappingUO = msgFor == 'ucm_out' ? 'UO' : msgFor == 'ffm' ? 'FFM' : 'CPM';
    // }

    const actiontype = keyType !== 'UCM Out' ? keyTypeMapping[keyType] : keyTypeMappingUO;
    const msgType = msgFor == 'ucm_out' ? ucmOutText : msgFor == 'ffm' ? ffmText : msgFor == 'cpm' ? cpmText : msgFor == 'ULD' ? uldProcessText : processText;
    try {
      const res = await withRFSToken.post(MSGPROCESSMVT, { message_type: actiontype, message: msgType });
      if (res.data.response_code == 200) {
        toast.success('Message processed');
        // setFormData(res.data.response_data);
        const responseData = res.data.response_data;
        const updatedForm = {
          ...responseData.Form, // Spread existing form data
          flight_or_truck: responseData.Form.flight_or_truck || 'F' // Add or retain flight_or_truck
        };
        console.log('100', res.data.response_data);
        const localStorageKey = keyType;
        const existingData = JSON.parse(localStorage.getItem(localStorageKey)) || [];
        const updatedData = {
          ...existingData,
          Form: updatedForm,
          ULD: responseData.uldInfo
        };
        localStorage.setItem(localStorageKey, JSON.stringify(updatedData));
        const event = new Event('localStorageUpdated');
        window.dispatchEvent(event);
        setIsLoading(false);
        setLoading(false);
      } else {
        toast.error(res.data.response_msg);
        setLoading(false);
      }
      // .then(function (res) {

      // });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <>
      {/* <Loader isLoading={isLoading} /> */}
      {console.log('ucmOutText', ucmOutText)}
      <div className='mb-3 nestedtabs rounded h-100'>
        {keyType == 'UCM Out' ? (
          <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="autometd">
            <Tab eventKey="UCM" title={<span>UCM Out</span>} className='moveto'>
              <div className='mt-3'>
                <div className='d-flex justify-content-between align-items-center charter_top '>
                  <h3 className='mb-0' >Automated {keyType} processing</h3>
                  <div className='zoom_up'>
                    <a href='#' onClick={handleInfoClick} className='msg_help' >  <FontAwesomeIcon icon={faCircleInfo} /> </a>
                    <a href='#' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                  </div>
                </div>

                <div className='au_proses ucmproses big_ucm'>
                  <Form.Group >
                    <Form.Control
                      as="textarea"
                      aria-label="With textarea"
                      type="text" style={{ resize: 'none' }}
                      name='ucm_out'
                      value={ucmOutText}
                      onChange={handleTextareaChange}
                    />
                  </Form.Group>
                  <div className='text-center mt-3'>
                    <Button variant="primary" className='process_btn' onClick={() => handleProcessButtonClick('ucm_out')}> Process {keyType} </Button>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="FFM" title={<span>FFM</span>} className='moveto'>
              <div className='mt-3'>
                <div className='d-flex justify-content-between align-items-center charter_top '>
                  <h3 className='mb-0'>Automated {activeTab} processing</h3>
                  <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                </div>

                <div className='au_proses ucmproses big_ucm'>
                  <Form.Group >
                    <Form.Control
                      as="textarea"
                      aria-label="With textarea"
                      type="text"
                      style={{ resize: 'none' }}
                      name='ffm'
                      value={ffmText}
                      onChange={handleTextareaChange}
                    />
                  </Form.Group>
                  <div className='text-center mt-3'>
                    <Button variant="primary" className='process_btn' onClick={() => handleProcessButtonClick('ffm')}> Process {activeTab} </Button>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="CPM" title={<span>CPM</span>} className='moveto'>
              <div className='mt-3'>
                <div className='d-flex justify-content-between align-items-center charter_top '>
                  <h3 className='mb-0'>Automated {activeTab} processing</h3>
                  <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                </div>

                <div className='au_proses ucmproses big_ucm'>
                  <Form.Group >
                    <Form.Control
                      as="textarea"
                      aria-label="With textarea"
                      type="text"
                      style={{ resize: 'none' }}
                      name='cpm'
                      value={cpmText}
                      onChange={handleTextareaChange}
                    />
                  </Form.Group>
                  <div className='text-center mt-3'>
                    <Button variant="primary" className='process_btn' onClick={() => handleProcessButtonClick('cpm')}> Process {activeTab} </Button>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="ULD" title={<span>ULD</span>} className='moveto'>
              <div className='mt-3'>
                <div className='d-flex justify-content-between align-items-center charter_top mb-2'>
                  <h3 className='mb-0'>Automated {activeTab} processing</h3>
                  <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                </div>

                <div className='au_proses ucmproses big_ucm'>
                  <Form.Group >
                    <Form.Control
                      as="textarea"
                      name='ULD'
                      aria-label="With textarea"
                      type="text"
                      style={{ resize: 'none' }}
                      value={uldProcessText}
                      onChange={handleTextareaChange}
                    />
                  </Form.Group>
                  <div className='text-center mt-3'>
                    <Button variant="primary" className='process_btn' onClick={() => handleProcessButtonClick('ULD')}> Process {activeTab} </Button>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        ) : (
          <div>
            <div className='d-flex justify-content-between align-items-center charter_top '>
              <h3 className='mb-0'>Automated {keyType} processing</h3>
              <div>
                <a href='#' onClick={handleInfoClick} className='msg_help'>  <FontAwesomeIcon icon={faCircleInfo} /> </a>
                <a href='#' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
              </div>

            </div>
            <div className={['UCM In'].includes(keyType) ? 'au_proses ucmproses big_ucm' : (['LUC Out', 'LUC In'].includes(keyType) ? 'au_proses ucmproses luc_area' : 'au_proses ucmproses')}>
              <Form.Group >
                <Form.Group >
                  <Form.Control
                    as="textarea"
                    name='process'
                    aria-label="With textarea"
                    type="text"
                    style={{ resize: 'none' }}
                    value={processText}
                    onChange={handleTextareaChange}
                  />
                </Form.Group>
              </Form.Group>
              <div className='text-center mt-3'><Button variant="primary" className='process_btn' onClick={() => handleProcessButtonClick('msg')}> Process {keyType} </Button></div>
            </div>
          </div>
        )}
      </div>
      <Modal show={showProcess} className={keyType == 'UCM Out' ? 'addfrom zoomcm' : 'addfrom'} onHide={handleCloseProcess} size="xl" centered>
        <Modal.Header closeButton>
          {keyType !== 'UCM Out' ? (<Modal.Title>Automated FFM processing</Modal.Title>) : ''}
        </Modal.Header>
        <Modal.Body>
          {keyType == 'UCM Out' ? (
            <>
              <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="autometd">
                <Tab eventKey="UCM" title={<span>UCM Out</span>} className='moveto'>
                  <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-center charter_top '>
                      <h3 className='mb-0' >Automated {keyType} processing</h3>
                      <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                    </div>

                    <div className='au_proses ucmproses bigpros'>
                      <Form.Group >
                        <Form.Control
                          as="textarea"
                          aria-label="With textarea"
                          type="text" style={{ resize: 'none' }}
                          name='ucm_out'
                          value={ucmOutText}
                          onChange={handleTextareaChange}
                        />
                      </Form.Group>
                      <div className='text-center mt-3'><Button variant="primary" className='process_btn'> Process {keyType} </Button></div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="FFM" title={<span>FFM</span>} className='moveto'>
                  <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-center charter_top '>
                      <h3 className='mb-0'>Automated {keyType} processing</h3>
                      <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                    </div>

                    <div className='au_proses ucmproses'>
                      <Form.Group >
                        <Form.Control
                          as="textarea"
                          aria-label="With textarea"
                          type="text"
                          style={{ resize: 'none' }}
                          name='ffm'
                          value={ffmText}
                          onChange={handleTextareaChange}
                        />
                      </Form.Group>
                      <div className='text-center mt-3'><Button variant="primary" className='process_btn'> Process {keyType} </Button></div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="CMP" title={<span>CPM</span>} className='moveto'>
                  <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-center charter_top '>
                      <h3 className='mb-0'>Automated {keyType} processing</h3>
                      <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                    </div>

                    <div className='au_proses ucmproses'>
                      <Form.Group >
                        <Form.Control
                          as="textarea"
                          aria-label="With textarea"
                          type="text"
                          style={{ resize: 'none' }}
                          name='cpm'
                          value={cpmText}
                          onChange={handleTextareaChange}
                        />
                      </Form.Group>
                      <div className='text-center mt-3'><Button variant="primary" className='process_btn'> Process {keyType} </Button></div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </>
          ) : (
            <>
              <div className='au_proses'>
                <Form.Group>
                  <Form.Control
                    as="textarea"
                    name='process'
                    aria-label="With textarea"
                    type="text"
                    style={{ resize: 'none' }}
                    value={processText}
                    onChange={handleTextareaChange}
                  />
                </Form.Group>
                <div className='text-center mt-3 mb-3'>
                  <Button variant="primary" className='process_btn' onClick={handleProcessButtonClick}>  Process {keyType} </Button>
                </div>
              </div>
            </>
          )
          }

        </Modal.Body>
      </Modal>
      <Modal show={showInfo} className='addfrom msg_standard' onHide={handleCloseInfo} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>{keyType} – Standard Messages </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {keyType == 'UCM Out' &&
            <>
              <p>UCM <br />
                ZZZ1455/23JAN.CFL.YUL<br />
                OUT<br />
                .PMC0064ZZZ/HKG/C.AKE5815ZZZ/HKG/C.PGA1212XY/YYC/C<br />
                .PMC0146ZZZ/YYC/B.PMC5604ZZZ/YYC/U
              </p>
              <hr />
              <p>
                UCM<br />
                ZZZ2233/25.ERBAM.HKG<br />
                IN<br />
                N.<br />
                OUT<br />
                .PMC0064ZZZ.AKE5815ZZZ.PMC5794ZZZ.PMC00376ZZZ.PMC0067ZZZ<br />
                .PMC0146ZZZ.PMC0186ZZZ.PMC5033ZZZ.PMC5168ZZZ.PMC5412ZZZ<br />
                .PMC5470ZZZ.PMC5604ZZZ.PMC5622ZZZ.PMC5673ZZZ.PMC5737ZZZ<br />
                .PMC5764ZZZ.PMC5798ZZZ.PMC5811ZZZ.PMC5932ZZZ.PMC6054ZZZ<br />
                SI
              </p>
              <hr />
              <p>
                UCM<br />
                F52235/27.ERBAM.HKG<br />
                OUT<br />
                .PMC0064ZZZ.AKE5815ZZZ.PMC5794ZZZ.PMC00376ZZZ.PMC0067ZZZ<br />
                .PMC0146ZZZ.PMC0186ZZZ.PMC5033ZZZ.PMC5168ZZZ.PMC5412ZZZ<br />
                .PMC5470ZZZ.PMC5604ZZZ.PMC5622ZZZ.PMC5673ZZZ.PMC5737ZZZ<br />
                .PMC5764ZZZ.PMC5798ZZZ.PMC5811ZZZ.PMC5932ZZZ.PMC6054ZZZ<br />
                SI
              </p>

            </>
          }
          {keyType == 'UCM In' &&
            <>
              <p>UCM<br />
                5Y003/23JAN24.CFND.YUL<br />
                IN<br />
                .PMC0064ZZZ.AKE5815ZZZ.PMC5794ZZZ.PMC00376ZZZ.PMC0067ZZZ
              </p>

            </>
          }
          {keyType == 'SCM' &&
            <>
              <p>
                SCM<br />
                YYC.21JAN24/1431<br />
                .PMC8001ZZZ.PMC8002ZZZ.PMC8003ZZZ.PMC8004ZZZ.PMC8005ZZZ.T5<br />
                .PMC9001ZZZ.PMC9002ZZZ.T2<br />
                .PMC3001ZZZ.T1<br />
                .PMC4001ZZZ.T1<br />
                SI
              </p>
              <hr />
              <p>
                SCM<br />
                BKK.06JAN/2355<br />
                .PMC.58401ZZZ/04056ZZZ/57610ZZZ/57645ZZZ/05656ZZZ/58041ZZZ.T6<br />
                .AKE.01733ZZZ.T01<br />
                SI
              </p>

            </>
          }
          {keyType.includes("LUC Out") &&
            <>
              <p>
                LUC<br />
                .PMC37285R7/10AUG13/1135/YYPANALP/CV/FRA/172-03247128/FRA/SER<br />
                .PMC33177R7/10AUG13/1135/YYPANALP/CV/FRA/172-13247128/FRA/DAM<br />
                .PMC39470R7/10AUG13/1135/YYPANALP/CV/FRA/172-23247128/FRA/SER<br />
                SI
              </p>
              {/* <p>
                LUC<br/>
                .PMC37285ZZZ/01AUG13/0353/YYPANALP/CV/FRA/172-03247128/FRA/SER<br/>
                .PMC33177ZZZ/01AUG13/0353/YYPANALP/CV/FRA/172-13247128/FRA/DAM<br/>
                .PMC39470ZZZ/01AUG13/0353/YYPANALP/CV/FRA/172-23247128/FRA/SER<br/>
                SI
              </p> */}

            </>
          }
          {keyType == 'LUC In' &&
            <>
              <p>
                LUC<br />
                .PMC37285ZZZ/01AUG13/0353/YYPANALP/CV/FRA/172-03247128/FRA/SER<br />
                .PMC33177ZZZ/01AUG13/0353/YYPANALP/CV/FRA/172-13247128/FRA/DAM<br />
                .PMC39470ZZZ/01AUG13/0353/YYPANALP/CV/FRA/172-23247128/FRA/SER<br />
                SI
              </p>

            </>
          }
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Process